export const TASK_TYPES = {
  ASSIGN_TO_PLAZA: 'Assign To Plaza',
  UNASSIGN_FROM_PLAZA: 'Unassign From Plaza',
  FW_UPDATE: 'FW Update',
  CONFIG_UPDATE: 'Config Update',
  CHANGE_CUSTOMER: 'Change Customer',
};

export const TASK_STATUSES = {
  ACTIVE: 'Active',
  SUPERSEDED: 'Superseded',
  REJECTED: 'Rejected',
};

export const EXECUTION_STATUSES = {
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
  CANCELED: 'Canceled',
  REJECTED: 'Rejected',
  QUEUED: 'Queued',
  IN_PROGRESS: 'In progress',
  REMOVED: 'Removed',
  TIMED_OUT: 'Timed out',
};

export const METRICS_PROFILE = {
  NORMAL: 'normal',
  CRITICAL: 'critical',
};

export const DEFAULT_METRICS = ['POWER_W', 'VOLTAGE_V', 'CURRENT_A', 'ENERGY_WH', 'TEMPERATURE_C', 'FREQUENCY_HZ'];

export const DEFAULT_EVENT_TYPES = ['CAR_PLUG_IN', 'OVERLOAD_PROTECTION', 'ROGUE_CHARGERS_DETECTED', 'CAR_PLUG_OUT', 'SESSION_STARTED'];

export const DEFAULT_COMPONENTS = [
  'com.iotecha.greengrass.em.EventAdapter',
  'com.iotecha.edge.telemetry.TelemetrySync',
  'com.iotecha.edge.logging.Agent',
];

export const LOG_LEVELS = ['DEBUG', 'INFO', 'WARN', 'ERROR'];

export const LOG_LEVEL_OPTIONS = LOG_LEVELS.map((level) => ({ label: level, value: level }));
